// Av Library video catalog, one section per agency (FBI / IC3, SSA, IRS, FTC).
// Videos are hosted on Cloudflare Stream; each entry is the Stream UID plus
// the display title (the "<Agency>_" prefix from the uploaded file name is
// dropped). Thumbnails are generated from the stream, at thumbTime seconds
// for videos that open on a black frame, unless an override
// image is given.

export const CLOUDFLARE_BASE = 'https://customer-c4ufb1bfafmxdcik.cloudflarestream.com';

const IMG = '/images/Feb18ServerSideRefactorImages';

export const VIDEO_SECTIONS = [
  {
    slug: 'fbi-ic3',
    label: 'FBI / IC3',
    title: 'FBI / IC3 Videos',
    hero: '/images/av-library/must-watch-hero.jpeg',
    videos: [
      { title: 'Abused in Salt Lake City', videoId: '2526c795bae13fc4066cddc2d9c85ea8' },
      { title: 'Agent Impersonation', videoId: '0ec2b522c1dbfd19af04482484cd50ac' },
      { title: 'Charity', videoId: '376950917f9be90008c32d1728bf7d4c' },
      { title: 'Dad Lost $700,000', videoId: '36c65c7022d204c4679c8813cdaf1cf0' },
      { title: 'For the Love of Money', videoId: 'fb6591769ce367fc5fd26a150ef44ae4' },
      { title: 'Fraud and Scam Awareness', videoId: 'ec48e95efd0cb979660f8f223b332fa9', thumbTime: 20 },
      { title: 'Grandparents', videoId: 'da6d80934d43507d87d2fa53e2eb9c10', thumbnail: `${IMG}/grandparent.png` },
      { title: 'Holiday Season Scams', videoId: '8748fb5b09cb0fcd361e032f9141f829', thumbTime: 2 },
      { title: 'If It Can Happen to Me', videoId: '89e86965c0af89db5ef4089b4f3fed4f', thumbnail: `${IMG}/CanHappenToMe.png` },
      { title: 'Money Mule', videoId: '5379fcb5ce54e97611b400045fd71bfd', thumbnail: `${IMG}/MoneyMule.png` },
      { title: 'Phantom Hacker', videoId: '258c3cffe9468d1685de94b6b0dbc57e' },
      { title: 'Romance Scams', videoId: '38df94231bed6e4e70a400a1ba66f279' },
      { title: 'Scam Red Flags', videoId: '721f55ec5c8cb2a23fef551c59250b0c' },
      { title: 'Scam Victim Impact', videoId: '3008ea6163dcfcadb045b1c1e46857f8', thumbTime: 2 },
      { title: 'Tech Support', videoId: '703889bdc600e71701cbe7421906d36b' },
      { title: 'File a Fraud Complaint', videoId: 'fd726392b1e2c4aba9ed0e589666af6c' },
    ],
  },
  {
    slug: 'ssa',
    label: 'SSA',
    title: 'SSA Videos',
    hero: '/images/av-library/ssa-hero.jpeg',
    videos: [
      { title: 'Fake Email Scam', videoId: 'f5f639aba1abe4a4b09adb8abc75f2d6' },
      { title: 'Slam the Scam', videoId: '7f7b81d6c64f689e7071e7142dc630a9' },
    ],
  },
  {
    slug: 'irs',
    label: 'IRS',
    title: 'IRS Videos',
    hero: '/images/av-library/irs-hero.jpeg',
    videos: [
      { title: 'Are They Calling Me', videoId: '2f899c615bf8d8184de67239adadd327', thumbTime: 6 },
      { title: 'Child Tax Credit Scam', videoId: '52f7227b15ecb363957b69610222de2e' },
      { title: 'Gift Card Scam', videoId: 'b160a638348d82eaf6c16db9ea98bf43' },
      { title: 'Phone Scams', videoId: '3ee54bd36708df3af0bea4287473942a' },
    ],
  },
  {
    slug: 'ftc',
    label: 'FTC',
    title: 'FTC Videos',
    hero: '/images/av-library/ftc-hero.jpeg',
    videos: [
      { title: 'Charity Disaster Scam', videoId: 'ed0bda3d0240fd5e4dfd98a688ab18d9', thumbTime: 2 },
      { title: 'Debt Settlement Companies', videoId: '041eeee993ba0a2eaa6a6f127c641e6c', thumbTime: 10 },
      { title: 'Employment Work From Home', videoId: '9181be344fd2170eea3568bfc79f8ee8', thumbTime: 2 },
      { title: 'Government Imposter Scams', videoId: '44821d199e0101f65cede7bd6c04c38f', thumbTime: 8 },
      { title: 'Health Insurance Open Enrollment Scams', videoId: 'd1236677e025598617b2438b17658da4' },
      { title: 'Job Scams', videoId: '4fbd6d6e0de0fe74791ce87b8733bee2' },
      { title: 'Medicare Scams', videoId: '89ee7b59147c9f84869254fadc24c6cf', thumbTime: 2 },
      { title: 'Money Transfer Scams', videoId: '1fe0be82498bb862479b72bd797811dd', thumbTime: 6 },
      { title: 'Repair Scam', videoId: 'a351397508ea2308c882c390ebe1f955' },
      { title: 'Social Security Imposters Scam', videoId: 'c6887796d7885bd74e794ac9b8b65332', thumbTime: 6 },
      { title: 'Spotting a Tech Support Scam', videoId: '29aefdf44a3f302e1ff5b825c42a1e3c', thumbTime: 6 },
      { title: 'Filing a Fraud Complaint', videoId: 'abb876aca11e9ee44a0ca3d2c8a32a38', thumbTime: 2 },
      { title: 'How to File a Complaint', videoId: 'f85cc7f71d9b89e75804fd13c4b7cc38' },
    ],
  },
];

export const DEFAULT_SECTION = VIDEO_SECTIONS[0].slug;

export const sectionBySlug = (slug) => VIDEO_SECTIONS.find((s) => s.slug === slug) || null;

// Every video across all sections, each tagged with its section slug, for
// the catalog dropdowns elsewhere in the hub.
export const VIDEOS = VIDEO_SECTIONS.flatMap((s) => s.videos.map((v) => ({ ...v, section: s.slug })));

export const videoPath = (video) =>
  `/dashboard/av-library/${video.section || DEFAULT_SECTION}?video=${video.videoId}`;

export const thumbnailUrl = (video) =>
  video.thumbnail || `${CLOUDFLARE_BASE}/${video.videoId}/thumbnails/thumbnail.jpg?time=${video.thumbTime ? `${video.thumbTime}s` : ''}&height=600`;

export const embedUrl = (video) =>
  `${CLOUDFLARE_BASE}/${video.videoId}/iframe?autoplay=true&poster=${encodeURIComponent(thumbnailUrl(video))}`;
